export default {"src":"/_next/static/media/gmaps.8b31c72a.svg","height":132,"width":92,"blurWidth":0,"blurHeight":0};